import axios from "axios";
// import store from '@/store/';
import router from "@/router/index";
import { baseUrl } from "@/config/env.js";
import { serialize } from "@/util/util.js";
import { getToken } from "@/util/auth";
import { Base64 } from "js-base64";
import { userStore } from "@/store/user.js";
import { navStore } from "@/store/nav.js";
import { loadingStore } from "@/store/loading.js";
import { getStore } from "@/util/store.js";
import { showToast, showDialog } from "vant";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";

const tokenHeader = "Blade-Auth";
let clientSecret = "wecom_secret";
let clientId = "wecom"; // 客户端id
let isLoginTimeoutCalled = false; // 添加401标志位
// 跳转 noBind 后，抑制此前已发出、尚未返回的请求错误提示
let suppressPendingErrorTips = false;

/**
 * 开启在途请求错误提示抑制（跳转 noBind 前调用）
 */
export const enableSuppressPendingErrorTips = () => {
  suppressPendingErrorTips = true;
};

/**
 * 关闭在途请求错误提示抑制（登录绑定成功离开 noBind 前调用）
 */
export const resetSuppressPendingErrorTips = () => {
  suppressPendingErrorTips = false;
};

/**
 * 统一提示方法
 * 根据当前页面类型选择不同的提示组件
 * H5页面使用vant的showToast，PC页面使用element-plus的ElMessage
 * @param {string} message - 提示消息内容
 * @param {string} type - 提示类型，默认为'error'，用于PC端element-plus
 */
const showMessage = (message, type = "error") => {
  // 跳转 noBind 后不再展示在途请求的错误提示
  if (suppressPendingErrorTips) {
    return;
  }

  // 判断是否为PC页面（路径以/pc开头）
  const isPcPage = window.location.pathname.startsWith("/pc");

  if (isPcPage) {
    // PC页面使用Element Plus的ElMessage
    ElMessage({
      message: message,
      type: type,
      duration: 3000,
    });
  } else {
    // H5页面使用Vant的showToast
    showToast(message);
  }
};

const logout = (message) => {
  // let last, timer, interval = 1000, now = new Date;
  // store.dispatch('FedLogOut').then(() => router.push({path: '/login'}));
  // if (last && now - last < interval) {
  //     clearTimeout(timer);
  // } else {
  //     last = now;
  //     singleMessage.error(message.substring(message.indexOf(":") + 1, message.length));
  //     return Promise.reject(new Error(message))
  // }
};

const testNeedLog = () => {
  //检验是否需要登录
  let pathname = window.location.pathname;
  let notlogPath = [];
  //  如果 notlogPath 包含  pathname 返回 false 否则返回 true
  return !notlogPath.includes(pathname);
};

/**
 * 当前是否在 nobind 登录绑定页（该页不展示 401 相关错误提示）
 * @returns {boolean}
 */
const isOnNoBindPage = () => {
  const routeName = router.currentRoute.value?.name;
  const pathName = window.location.pathname || "";
  return routeName === "noBind" || pathName.includes("/nobind");
};

axios.defaults.withCredentials = false;

axios.defaults.baseURL = baseUrl;

axios.interceptors.response.use(
  (res) => {
    try {
      res.data = JSON.parse(res.data);
    } catch (error) {
      // console.warn('Error parsing decrypted data as JSON');
    }

    const aloginStoreuth = userStore();
    //获取状态码
    const status = res.data.code || res.status;
    const message = res.data.msg || res.data.error_description || "未知错误";

    if (
      res.data.error_description &&
      res.data.error_description.includes("账号未绑定企微")
    ) {
      aloginStoreuth.isLogErr = true;
      //router.push({ path: "/loginFailed" })
    }

    if (
      res.data.error_description &&
      res.data.error_description.includes("账号已冻结")
    ) {
      aloginStoreuth.isLogErr = true;
    }

    //错误处理

    // if (status === 401) {
    //   //跳转到 loginFailed 路由
    //   showToast('登录失效')
    //   //singleMessage.error("登录失效");
    //   //重新登录获取TOKEN
    //   // aloginStoreuth
    //   // router.push({ name: "loginFailed" });
    // }else if(status === 503){
    //   showToast('系统升级维护中')
    //   router.push({ name: "503" });
    // }else if (status === 413) {

    //   showToast('上传的文件过大！')
    //   return Promise.reject(new Error(message));
    // }else if (status===404){
    //   showToast("服务繁忙，请稍后重试");
    //   return Promise.reject(new Error(message));
    // } else if (status !== 200 && status !== 401) {
    //   showToast(
    //      message.substring(message.indexOf(":") + 1, message.length)
    //   );
    // }

    switch (status) {
      case 401:
        // nobind 页不展示 401 登录失效提示
        if (!isOnNoBindPage()) {
          showMessage("登录失效");
        }
        break;
      case 503:
        showMessage("系统升级维护中");
        router.push({ name: "503" });
        break;
      case 413:
        showMessage("上传的文件过大！");
        return Promise.reject(new Error(message));
      case 404:
        showMessage("服务繁忙，请稍后重试");
        return Promise.reject(new Error(message));
      default:
        if (status !== 200) {
          showMessage(
            message.substring(message.indexOf(":") + 1, message.length),
          );
        }
    }

    return res;
  },
  (error) => {
    const loading = loadingStore();
    loading.hideLoading();

    const needLog = testNeedLog();
    console.log(needLog ? "需要登录" : "不需要登录");

    let response = {};
    try {
      response = JSON.parse(error.request.response);
    } catch (error) {
      // console.warn('Error parsing decrypted data as JSON');
    }


    // 如果有 error_description，将其赋值给 msg 字段
    if (response && response.error_description) {
      response.msg = response.error_description;
    }

  

    // 账号未绑定企微：先抑制在途错误提示，再跳转 noBind，避免本条及后续在途请求弹 tip
    const isUnboundWecom =
      response.error &&
      response.error_description &&
      response.error_description.includes("账号未绑定企微");

    if (isUnboundWecom) {
      if (needLog) {
        enableSuppressPendingErrorTips();
        // 跳转 noBind 前记录当前路由，登录成功后可回跳
        const nav = navStore();
        nav.setFirstOpenPath(router.currentRoute.value.fullPath);
        router.push({ name: "noBind" });
        setTimeout(() => {
          resetSuppressPendingErrorTips();
        }, 2000);
      } else if (window.location.pathname.includes("/pushPage")) {
        //推送页面进来的
        router.push({ name: "pushPage" });
      }
    } else if (response.msg) {
      // nobind 页不展示 401 相关错误提示
      const isHttp401 = error.response?.status == 401;
      if (!isHttp401){
        showMessage(response.msg);
      }
    }

    if (error.response.status == 401 && needLog) {
      // nobind 页不弹 401 登录超时提示
      if (!isOnNoBindPage()) {
        const aloginStoreuth = userStore();
        if (!isLoginTimeoutCalled) {
          isLoginTimeoutCalled = true; // 设置标志位
          aloginStoreuth.loginTimeout();
          setTimeout(() => {
            isLoginTimeoutCalled = false;
          }, 5000);
        }
      }
    }

    if (error.response.status == 503) {
      showMessage("系统升级维护中");
      router.push({ name: "503" });
    }

    if (response) {
      console.log(response);
    }

    if (!isUnboundWecom && !isOnNoBindPage()) {
      if (response.error && response.error === "invalid_token") {
        const aloginStoreuth = userStore();
        aloginStoreuth.loginTimeout(
          "账号长时间未登录",
          "点击确定后刷新登录状态",
        );
      } else if (response.error && response.error === "invalid_grant") {
        const aloginStoreuth = userStore();
        //其他情况统一提示错误，错误原因并清空缓存刷新
        aloginStoreuth.loginTimeout("错误", response.error_description);
      }
    }

    if (error?.response?.status) {
      const status = error.response.status;
      if (status === 503 && error.response.data.data == "000000") {
        // Upgradepage("/503");
        return Promise.reject(new Error(error));
      }
    }


    if (error.message.indexOf("timeout") > -1) {
      showMessage("请求超时！");
    }

    if (error.message.indexOf("Network Error") > -1) {
      showMessage("网络错误，请检查是否正确连接互联网");
    }

    return Promise.reject(new Error(error));
  },
);

axios.interceptors.request.use(
  (config) => {
    //开启 progress bar

    // NProgress.start();
    const meta = config.meta || {};

    // isToken 为 false 时不携带 Blade-Auth（登录类接口需排除，否则后端报错）
    const isToken = meta.isToken === false;

    config.headers["Authorization"] = `Basic d2Vjb206d2Vjb21fc2VjcmV0`;

    //让每个请求携带token（请求已显式带 Blade-Auth 时不覆盖，供绑定接口使用新 token）
    if (!isToken) {
      const aloginStoreuth = userStore();
      const token = aloginStoreuth.token;
      if (token && !config.headers[tokenHeader]) {
        config.headers[tokenHeader] = "bearer " + token;
      }
    }

    //headers中配置text请求
    if (config.text === true) {
      config.headers["Content-Type"] = "text/plain";
    }

    //headers中配置serialize为true开启序列化
    if (config.method === "post" && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }

    return config;
  },
  (error) => {
    // singleMessage.error("网络错误，无法发送请求");
    return Promise.reject(error);
  },
);

export default axios;
